/**
 * The two legal pages of the MVP (`Termos e Condicoes.dc.html` and `Politica de Privacidade.dc.html`
 * in the final design package), as data: the wording is Legal's, the drawing is one component.
 */

/** A run of text, plain or in the design's `<strong>` (weight 500, oxide ink). */
export type LegalRichText = readonly (string | { strong: string })[];

export type LegalBlock =
  /** The opening paragraph: larger, in full ink. */
  | { kind: "lead"; text: LegalRichText }
  | { kind: "paragraph"; text: LegalRichText }
  /** A heading inside a section ("Dados de identificação · anfitriões e convidados"). */
  | { kind: "subhead"; text: LegalRichText }
  /** An aside under a green rule. */
  | { kind: "note"; text: LegalRichText }
  | { kind: "list"; items: readonly LegalRichText[] }
  /** The Concierge's e-mail and WhatsApp, as the two ruled links the design draws. */
  | { kind: "contact" };

export type LegalSection = {
  number: string;
  title: string;
  blocks: readonly LegalBlock[];
};

export type LegalDocument = {
  /** Banner title, before its accented word. */
  title: string;
  /** The banner's last word, in Bulhões Green. */
  titleAccent: string;
  eyebrow: string;
  intro: readonly LegalBlock[];
  sections: readonly LegalSection[];
};

export const TERMS_HREF = "/termos-e-condicoes";
export const PRIVACY_HREF = "/politica-de-privacidade";
